import { differenceInMonths } from 'date-fns';
import { getAppVersion } from 'shared/envUtils';
import { getDateFromCalVer } from './getDateFromCalVer.utils';

export const getAppVersionAgeInMonths = async (): Promise<number> => {
  const currentAppVersion = await getAppVersion();
  const currentVersionDate = getDateFromCalVer(currentAppVersion);
  return differenceInMonths(new Date(), currentVersionDate);
};
